export default __webpack_public_path__ + "static/media/11.07cf605d.png";